import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { adjustTaskOwner as _adjustTaskOwner } from '@/api/qa/task';
import { adjustDemandOwner as _adjustDemandOwner } from '@/api/demand/demand';

export default {
  props: {
    userList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },

    query: {
      type: Object,
      required: true
    },

    selection: {
      type: Array,
      required: true
    },

    transformTypes: {
      type: Object
    },

    roleTypes: {
      type: Object
    },

    isOtherRoles: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      popover: {
        visible: false
      },
      formConfig: {
        inline: false,
        labelPosition: 'top'
      },
      formValue: {
        manager: ''
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      return [{
        label: '新负责人',
        prop: 'manager',
        type: 'select',
        rules: [{
          required: true,
          trigger: 'change',
          message: '新负责人是必填项'
        }],
        params: {
          placeholder: '新负责人',
          clearable: true,
          filterable: true,
          options: this.userList
        }
      }];
    },
    submitButton: function submitButton() {
      return {
        type: 'primary',
        size: 'mini',
        loading: false,
        disabled: !this.submitButtonEnabled || this.formValue.manager === ''
      };
    },
    submitButtonEnabled: function submitButtonEnabled() {
      var roleType = Number(this.query.role_type);
      var transformType = Number(this.query.transform_type);

      // 测试
      if (roleType === this.roleTypes.tester) {
        return true;
      }

      // 设计师/开发/提需人
      if (this.isOtherRoles(roleType)) {
        if (transformType === this.transformTypes.demand) {
          return true;
        }
        if (transformType === this.transformTypes.task) {
          return true;
        }
      }

      return false;
    }
  },

  methods: {
    hidePopover: function hidePopover() {
      this.popover.visible = false;
      this.$refs.form.resetFields();
      this.$refs.form.clearValidate();
    },
    submit: function submit() {
      var _this = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var roleType = Number(_this.query.role_type);
          var transformType = Number(_this.query.transform_type);

          // 测试
          if (roleType === _this.roleTypes.tester) {
            _this.adjustTaskOwner({
              type: roleType,
              ids: _this.selection,
              owner_id: _this.formValue.manager
            });
          }

          // 设计师/开发/提需人
          if (_this.isOtherRoles(roleType)) {
            if (transformType === _this.transformTypes.demand) {
              _this.adjustDemandOwner({
                type: roleType,
                ids: _this.selection,
                owner_id: _this.formValue.manager
              });
            }
            if (transformType === _this.transformTypes.task) {
              _this.adjustTaskOwner({
                type: roleType,
                ids: _this.selection,
                owner_id: _this.formValue.manager
              });
            }
          }
        }
      });
    },
    adjustTaskOwner: function adjustTaskOwner(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.submitButton.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return _adjustTaskOwner(params);

              case 4:
                _this2.$message.success('调整任务归属成功');
                _this2.submitButton.loading = false;
                _this2.hidePopover();
                _this2.$emit('adjust-success');
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                _this2.submitButton.loading = false;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 10]]);
      }))();
    },
    adjustDemandOwner: function adjustDemandOwner(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.submitButton.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _adjustDemandOwner(params);

              case 4:
                _this3.$message.success('调整任务归属成功');
                _this3.submitButton.loading = false;
                _this3.hidePopover();
                _this3.$emit('adjust-success');
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                _this3.submitButton.loading = false;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 10]]);
      }))();
    }
  }
};